export default "__VITE_ASSET__BNpXRtiX__"